import cx from 'classnames';
import _ from 'lodash';
import React, { useState } from 'react';
import { Key } from 'w3c-keys';
import { Icon, IconColor, IconID, IconSize } from '../../icon';
import styles from './input-base.module.scss';
export var InputVariant;
(function (InputVariant) {
    InputVariant["DEFAULT"] = "default";
    InputVariant["NUMBER"] = "number";
})(InputVariant || (InputVariant = {}));
export const InputBase = ({ className, name, onEnter, onTab, onSpace, onEscape, onKeyDown, onFocus, onBlur, value = '', onChange, helperText, disabled = false, hasError = false, hasWarning = false, onGrayBackground = false, suffix = null, prefix = null, type = 'text', isVerified = false, readOnly = false, inputRef, variant = InputVariant.DEFAULT, isFormatterPresent = false, helperRef, ...restProps }) => {
    const [hasFocus, setHasFocus] = useState(false);
    const isInputNumberVariant = variant === InputVariant.NUMBER;
    const handleFocus = (event) => {
        setHasFocus(true);
        if (onFocus) {
            onFocus(event);
        }
    };
    const handleBlur = (event) => {
        setHasFocus(false);
        if (onBlur) {
            onBlur(event);
        }
    };
    const handleChange = (event) => {
        const { value: val } = event.target;
        /* If Variant is input-number, then don't allow text as input unless some Formatter is present.
           If Formatter is present then input-number will allow character input
           and the formatting, parsing logic will be handled by input-number as earlier */
        if (isInputNumberVariant && !isFormatterPresent) {
            const isOnlyMinus = val === '-'; // Edge case. Where user enters '-', isNaN check fails. So we need to skip this case.
            // eslint-disable-next-line no-new-wrappers
            if (!isOnlyMinus && _.isNaN(new Number(val))) {
                return;
            }
        }
        // https://github.com/facebook/react/issues/955#issuecomment-469352730
        onChange(event);
    };
    const handleKeyDown = (event) => {
        if (event.key === Key.Enter && onEnter) {
            onEnter(event);
        }
        else if (event.key === Key.Escape && onEscape) {
            onEscape(event);
        }
        else if (event.key === Key.Tab && onTab) {
            onTab(event);
        }
        else if (event.key === Key.Space && onSpace) {
            onSpace(event);
        }
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    const containerClassNames = cx(className, styles.container, {
        [styles.disabled]: disabled,
        [styles.hasError]: hasError,
        [styles.hasWarning]: hasWarning,
        [styles.hasFocus]: hasFocus,
        [styles.onGrayBackground]: onGrayBackground,
        [styles.readOnly]: readOnly,
    });
    const suffixClassNames = cx(styles.suffix, {
        [styles.inputNumberSuffix]: className === null || className === void 0 ? void 0 : className.includes('inputNumber'),
    });
    const getHelpTextMarkup = () => {
        if (helperText) {
            const helperTextClassName = cx(styles.helperText, {
                [styles.hasError]: hasError,
                [styles.hasWarning]: hasWarning,
                [styles.disabled]: disabled,
            });
            return (React.createElement("span", { className: helperTextClassName, "aria-live": "assertive", tabIndex: -1, ref: helperRef },
                hasError && (React.createElement("span", { className: styles.iconStyle },
                    React.createElement(Icon, { color: IconColor.TEXT_COLOR, size: IconSize.XSMALL, id: IconID.EXCLAMATION_POINT_CIRCLE }))),
                isVerified && !hasError && (React.createElement("span", { className: styles.iconStyle },
                    React.createElement(Icon, { color: IconColor.GREEN, size: IconSize.XSMALL, id: IconID.CHECKMARK_CIRCLE }))),
                helperText));
        }
        return null;
    };
    return (React.createElement("div", { "data-radiant-v2": true },
        React.createElement("span", { className: containerClassNames },
            prefix && React.createElement("span", { className: styles.prefix }, prefix),
            React.createElement("input", { disabled: disabled, type: type, value: value, onKeyDown: handleKeyDown, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, className: styles.input, readOnly: readOnly, ref: inputRef, ...restProps }),
            suffix && React.createElement("span", { className: suffixClassNames }, suffix)),
        getHelpTextMarkup()));
};
//# sourceMappingURL=input-base.js.map